import { appearanceFields } from '../../services/appearance/appearance';

/** Child fields let CAP own loading, validation, save/cancel and dirty navigation. */
export function appearanceEditorSection(team: boolean): any {
    return { sectionType: 'fitnessAppearanceEditor', team, showTitle: false,
        sections: [{ sectionType: 'form', showTitle: false,
            fields: appearanceFields.map(attrName => ({ attrName, columnItemPreferences: {} })) }] };
}
